import {encounterStatusLabel} from "../../../../../utils/enums/encounter-status-enum.js";

export const OCCURRENCE_REASON = {
    SUPPORT: "APOIO À GUARNIÇÃO",
    PANIC: "PÂNICO",
    REFUELLING: "Abastecimento",
    MAINTENANCE: "Manutenção",
    LEADER_SUPERVISION: "Fiscalização do responsável",
    RESERVATION_CAUSE: "Reserva de imagem",
};

export const ENTITY_BO_OPTIONS = [
    {value: "BO/CM", label: "BO/CM"},
    {value: "BO/GM", label: "BO/GM"},
    {value: "BO/PC", label: "BO/PC"},
    {value: "BO/PF", label: "BO/PF"},
    {value: "BO/PM", label: "BO/PM"},
];

const hasValue = (value) => value !== null && value !== undefined && value !== "";

const orNull = (value) => (hasValue(value) ? value : null);

const orUndefined = (value) => (hasValue(value) ? value : undefined);

export const onlyDigits = (value) => (value ?? "").toString().replace(/[^0-9]+/g, "");

export const emptyLocation = () => ({
    place: "",
    placeId: "",
    type_place: "",
    street: "",
    number: "",
    neighborhood: "",
    crossroads: "",
    reference_point: "",
    city: "",
    latitude: "",
    longitude: "",
    sectors: [],
});

export const mapNatureOptions = (list = []) =>
    list.map(nature => ({value: nature.name ?? nature.alias, label: nature.alias ?? nature.name}));

export const mapStringOptions = (list = []) =>
    list.map(item => (typeof item === "string" ? {value: item, label: item} : {value: item.value ?? item.name, label: item.label ?? item.name}));

export const mapGarrisonOptions = (list = []) =>
    list.map(item => ({value: item.id, label: item.name}));

export const mapSupportGarrisonOptions = (list = []) =>
    list.map(item => ({
        value: item.id,
        label: item.name,
        supportForGarrison: item.dispatch_id ?? item.dispatchId ?? null,
    }));

export const mapRetroactiveGarrisonOptions = (list = [], formatDate) =>
    list.map(item => ({
        value: item.id,
        label: `${item.name} - Início ${formatDate(item.start)}`,
    }));

export const mapRetroactiveSupportOptions = (list = []) =>
    list.map(item => {
        const taloLabel = item.dispatchNumbercheckbook != null ? ` - Talão ${item.dispatchNumbercheckbook}` : " - Sem talão";
        return {
            value: item.garrisonId,
            label: `${item.garrisonName}${taloLabel}`,
            supportForGarrison: item.dispatchId ?? null,
        };
    });

export const buildAttendanceOption = (item) => {
    const part = (prefix, value, undefinedCheck = false) =>
        (undefinedCheck ? value !== undefined : (value != null && value !== "")) ? ` - ${prefix}${value}` : "";

    const label = item.protocol +
        part("", item.nature) +
        part("", item.contactPhone) +
        part("", item.contactName) +
        part("", item.factType) +
        part("", item.factPlace) +
        part("", item.factCrossroads) +
        part("", item.factStreet) +
        part("", item.factNumber, true) +
        part("", item.factReferencePoint, true) +
        part("", item.factNeighborhood) +
        part("", item.sectors) +
        (item.attendanceLinked && item.attendanceLinked !== "" ? ` - Vinculado: ${item.attendanceLinked}` : "") +
        part("", item.isDispatch.replace("-", "")) +
        part("", item.start, true);

    return {value: item.id, label, start: item.start};
};

export const factToLocation = (dispatch = {}) => ({
    ...emptyLocation(),
    place: dispatch.factPlace ?? "",
    type_place: dispatch.factType ?? "",
    street: dispatch.factStreet ?? "",
    number: dispatch.factNumber ?? "",
    neighborhood: dispatch.factNeighborhood ?? "",
    crossroads: dispatch.factCrossroads ?? "",
    reference_point: dispatch.factReferencePoint ?? "",
    city: dispatch.factCity ?? "",
    latitude: dispatch.factLatitude ?? "",
    longitude: dispatch.factLongitude ?? "",
    sectors: dispatch.sectors ?? [],
});

const locationToFact = (location = {}) => {
    return {
        factPlace: orNull(location.place),
        factType: orNull(location.type_place),
        factStreet: orNull(location.street),
        factNumber: orNull(location.number),
        factNeighborhood: orNull(location.neighborhood),
        factCrossroads: orNull(location.crossroads),
        factReferencePoint: orNull(location.reference_point),
        factCity: orNull(location.city),
        factLatitude: orNull(location.latitude),
        factLongitude: orNull(location.longitude),
    };
};

export const destinyToLocation = (row = {}) => ({
    ...emptyLocation(),
    place: row.destiny ?? "",
    type_place: row.destinyType ?? "",
    street: row.destinyStreet ?? "",
    number: row.destinyNumber ?? "",
    neighborhood: row.destinyNeighborhood ?? "",
    crossroads: row.destinyCrossroads ?? "",
    reference_point: row.destinyReferencepoint ?? "",
    city: row.destinyCity ?? "",
    latitude: row.destinyLatitude ?? "",
    longitude: row.destinyLongitude ?? "",
});

const locationToDestiny = (location = {}) => {

    return {
        destiny: orUndefined(location.place),
        destinyType: orUndefined(location.type_place),
        destinyStreet: orUndefined(location.street),
        destinyNumber: orUndefined(location.number),
        destinyNeighborhood: orUndefined(location.neighborhood),
        destinyCrossroads: orUndefined(location.crossroads),
        destinyReferencepoint: orUndefined(location.reference_point),
        destinyCity: orUndefined(location.city),
        destinyLatitude: orUndefined(location.latitude),
        destinyLongitude: orUndefined(location.longitude),
    };
};

export const displacementSummary = (location = {}) => {
    if (hasValue(location.place)) return location.place;
    return [location.neighborhood, location.street, location.number].filter(hasValue).join(" - ") || location.city || "";
};

export const encounterLinkLabel = (encounter = {}) => {
    const status = encounterStatusLabel(encounter.status);
    const start = encounter.dtStart || `#${encounter.encounterId}`;
    return status ? `${start} (${status})` : start;
};

const buildDisplacementPayload = (rows = [], garrisonId, vehicle) =>
    rows.map(row => {
        const payload = {
            garrison: {id: garrisonId || ""},
            vehicle,
            goingDate: orUndefined(row.goingDate),
            arrivalDate: orUndefined(row.arrivalDate),
            goingMileage: orUndefined(row.goingMileage),
            arrivalMileage: orUndefined(row.arrivalMileage),
            ...locationToDestiny(row.location),
        };
        if (hasValue(row.id)) payload.id = row.id;
        return payload;
    });

export const buildImageReservation = (imageReservation, cameraRows = [], nature) => {
    if (nature !== OCCURRENCE_REASON.RESERVATION_CAUSE) return null;

    const cause = imageReservation.cause ?? [];
    const attendanceId = hasValue(imageReservation.attendanceId) ? parseInt(imageReservation.attendanceId) : null;
    const dtFact = orNull(imageReservation.dtFact);

    const cameras = cameraRows.map(camera => ({
        itemId: orUndefined(camera.itemId),
        cameraId: hasValue(camera.cameraId) ? parseInt(camera.cameraId) : null,
        cameraName: orNull(camera.cameraName),
        vmsId: hasValue(camera.vmsId) ? parseInt(camera.vmsId) : null,
        dtStart: orNull(camera.dtStart),
        dtEnd: orNull(camera.dtEnd),
    }));

    if (cause.length > 0 || attendanceId || dtFact || cameras.length > 0) {
        return {cause, attendanceId, dtFact, cameras};
    }

    return null;
};

export const buildDispatchModel = ({
    state,
    location,
    displacementRows,
    garrisonVehicle,
    retroactive,
    actions,
    imageReservation,
    refuellingList,
    maintenanceList,
    attachment,
    attachmentDescription,
}) => {
    const isSupport = hasValue(state.supportForGarrison);

    const finalized = !!state.finalized;
    const garrisonValue = state.garrison || "";
    const supervisionId = state.nature === OCCURRENCE_REASON.LEADER_SUPERVISION
        ? parseInt(state.supervisionGarrison) || ""
        : "";

    const fact = locationToFact(location);

    const sectors = (location.sectors ?? []).filter(hasValue);

    const supportForGarrisonDispatchId = parseInt(state.supportForGarrisonDispatch) || undefined;

    const model = {
        id: orUndefined(state.id),
        retroactive: retroactive ? "true" : "false",
        systemUpdate: orNull(state.systemUpdate) ?? "",
        addNew: actions.addNew,
        addNewHome: actions.addNewHome,
        start: orNull(state.start),
        end: state.end ? (finalized ? state.end : null) : null,
        nature: isSupport ? OCCURRENCE_REASON.SUPPORT : orNull(state.nature),
        supervisionGarrison: {id: supervisionId},
        activity: state.activity ? "true" : "false",
        providence: orNull(state.providence),
        attendance: {id: state.attendanceId || ""},
        sectors: sectors.length > 0 ? sectors : null,
        contactPhone: orNull(onlyDigits(state.contactPhone)),
        contactName: orNull(state.contactName),
        contactCpf: orNull(onlyDigits(state.contactCpf)),
        ...fact,
        initialObservation: orNull(state.initialObservation),
        garrison: {id: garrisonValue},
        supportForGarrison: isSupport ? {id: state.supportForGarrison} : null,
        supportForGarrisonDispatch: supportForGarrisonDispatchId ? {id: supportForGarrisonDispatchId} : null,
        displacement: buildDisplacementPayload(displacementRows, garrisonValue, garrisonVehicle),
        finalObservation: orNull(state.finalObservation),
        cancelSupport: state.cancelSupport,
        flagrant: state.flagrant,
        infracionalAct: state.infracionalAct,
        publicPatrimony: state.publicPatrimony,
        notFound: state.notFound,
        policeAuthority: state.policeAuthority,
        indicted: state.indicted,
        notCriminal: state.notCriminal,
        status: !finalized,
        otherOccurrenceNumber: (state.otherOccurrenceNumber ?? []).length > 0 ? state.otherOccurrenceNumber : undefined,
        attachment: (attachment ?? []).length > 0 ? attachment : null,
        attachmentDescription: (attachmentDescription ?? []).length > 0 ? attachmentDescription : null,
        refuellingList: refuellingList ?? null,
        maintenanceList: maintenanceList ?? null,
        imageReservation,
        finalized,
    };

    if (isSupport) {
        model.flagrant = null;
        model.infracionalAct = null;
        model.publicPatrimony = null;
        model.notFound = null;
        model.policeAuthority = null;
        model.contactPhone = null;
        model.contactName = null;
        model.contactCpf = null;
        model.factPlace = null;
        model.factNeighborhood = null;
        model.factStreet = null;
        model.factCrossroads = null;
        model.factReferencePoint = null;
        model.factNumber = null;
        model.factLatitude = null;
        model.factLongitude = null;
        model.otherOccurrenceNumber = undefined;
    }

    return model;
};
